import { FaChevronRight, FaChevronLeft } from "react-icons/fa6";
import { useSnapshot } from 'valtio';
import { AppStore } from '../store/store';
import { useStoreActions } from '../store/actions';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import cls from '../styles/Block.module.scss';

const BlockA = () => {
  const {
    incrementSelectedFloor,
    decrementSelectedFloor,
    onHoverOverFloor,
    goPrevPage,
  } = useStoreActions();

  const { selectedFloor } = useSnapshot(AppStore);

  const goToFloor = (floor: number) => {
    AppStore.currentPage = 31;
    AppStore.selectedFloor = floor;
  };

  return (
    <div className={cls.mainContainer}>
      <div onClick={() => goPrevPage(10)} className={cls.mobileNavigationButton}>
        <img src="./images/arrow.png" alt="Назад" />
        <p>К выбору блока</p>
      </div>

      <div className={cls.infoContainer}>
        <div className={cls.selectionScreen}>
          <div className={cls.selectionBody}>
            <button onClick={decrementSelectedFloor} className={cls.arrowButton}>
              <FaChevronLeft />
            </button>
            <div className={cls.selectedBlock}>
              <p>Этаж</p>
              <p>{selectedFloor}</p>
            </div>
            <button onClick={incrementSelectedFloor} className={cls.arrowButton}>
              <FaChevronRight />
            </button>
          </div>
        </div>

        <div className={cls.detailsContainer}>
          <div className={cls.detailItem}>
            <div className={cls.imageWrapper}>
              <LazyLoadImage
                src="./images/rooms/BlockA/1.png"
                alt="Комната 1"
                effect="blur"
              />
            </div>
            <div className={cls.textWrapper}>
              <p>1-комнатные</p>
              <p><span>Количество на этаже:</span> <span>2</span></p>
            </div>
          </div>

          <div className={cls.detailItem}>
            <div className={cls.imageWrapper}>
              <LazyLoadImage
                src="./images/rooms/BlockA/2.png"
                alt="Комната 2"
                effect="blur"
              />
            </div>
            <div className={cls.textWrapper}>
              <p>2-комнатные</p>
              <p><span>Количество на этаже:</span> <span>2</span></p>
            </div>
          </div>

          <div className={cls.detailItem}>
            <div className={cls.imageWrapper}>
              <LazyLoadImage
                src="./images/rooms/BlockA/3.png"
                alt="Комната 3"
                effect="blur"
              />
            </div>
            <div className={cls.textWrapper}>
              <p>3-комнатные</p>
              <p><span>Количество на этаже:</span> <span>2</span></p>
            </div>
          </div>

          <div className={cls.detailItem}>
            <div className={cls.imageWrapper}>
              <LazyLoadImage
                src="./images/rooms/BlockA/4.png"
                alt="Комната 4"
                effect="blur"
              />
            </div>
            <div className={cls.textWrapper}>
              <p>4-комнатные</p>
              <p><span>Количество на этаже:</span> <span>2</span></p>
            </div>
          </div>
        </div>

        <button onClick={() => goToFloor(selectedFloor)} className={cls.selectButton}>
          Выбрать
        </button>
      </div>

      <div className={cls.imageContainer}>
        <div onClick={() => goPrevPage(10)} className={cls.navigationButton}>
          <img src="./images/arrow.png" alt="Назад" />
          <p>К выбору блока</p>
        </div>

        <div className={cls.imageBody}>
          <svg viewBox="0 0 1180 837.33331">
            <path onClick={() => goToFloor(3)} onMouseOver={() => onHoverOverFloor(3)} className={cls.floor3} fill="#3292ffcc" d="m 230.41517,714.3231 585.5935,-36.4193 138.10487,19.11112 0.36059,-29.20756 L 813.84515,643.64802 229.694,690.16376"></path>
            <circle className={`${cls.symbol3} ${cls.hidden}`} cx="960" cy="675" r="35" fill="#333333" />
            <text className={`${cls.symbol3} ${cls.hidden}`} x="960" y="670" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol3} ${cls.hidden}`} x="960" y="695" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">3</text>

            <path onClick={() => goToFloor(4)} onMouseOver={() => onHoverOverFloor(4)} className={cls.floor4} fill="#3292ffcc" d="M 230.86591,685.34091 814.06697,632.52577 953.79251,657.57692 952.83636,622.19934 813.755,595.2392 230.86591,660.55055"></path>
            <circle className={`${cls.symbol4} ${cls.hidden}`} cx="960" cy="635" r="35" fill="#333333" />
            <text className={`${cls.symbol4} ${cls.hidden}`} x="960" y="630" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol4} ${cls.hidden}`} x="960" y="655" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">4</text>

            <path onClick={() => goToFloor(5)} onMouseOver={() => onHoverOverFloor(5)} className={cls.floor5} fill="#3292ffcc" d="m 230.75111,654.07104 582.91375,-68.83813 140.62898,30.8302 -0.36059,-24.70022 -141.71074,-44.7128 -582.04509,84.09086"></path>
            <circle className={`${cls.symbol5} ${cls.hidden}`} cx="960" cy="595" r="35" fill="#333333" />
            <text className={`${cls.symbol5} ${cls.hidden}`} x="960" y="590" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol5} ${cls.hidden}`} x="960" y="615" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">5</text>

            <path onClick={() => goToFloor(6)} onMouseOver={() => onHoverOverFloor(6)} className={cls.floor6} fill="#3292ffcc" d="m 231.0462,623.63544 136.84282,-20.37317 14.96436,1.71278 430.27059,-68.6017 48.04938,13.85969 9.1153,-1.21113 82.67519,28.87576 0.12749,-31.23426 -139.15184,-44.42915 -431.22411,76.17336 -14.27852,-2.03979 -137.49452,24.41372"></path>
            <circle className={`${cls.symbol6} ${cls.hidden}`} cx="960" cy="555" r="35" fill="#333333" />
            <text className={`${cls.symbol6} ${cls.hidden}`} x="960" y="550" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol6} ${cls.hidden}`} x="960" y="575" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">6</text>

            <path onClick={() => goToFloor(7)} onMouseOver={() => onHoverOverFloor(7)} className={cls.floor7} fill="#3292ffcc" d="m 230.04993,595.36336 137.83909,-24.82438 14.46856,1.84801 431.03683,-81.8082 140.2684,48.13838 -0.18902,-32.84954 -139.02436,-51.56841 -432.62646,91.85424 -13.83232,-4.01584 -137.75577,29.39298"></path>
            <circle className={`${cls.symbol7} ${cls.hidden}`} cx="960" cy="510" r="35" fill="#333333" />
            <text className={`${cls.symbol7} ${cls.hidden}`} x="960" y="505" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol7} ${cls.hidden}`} x="960" y="530" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">7</text>

            <path onClick={() => goToFloor(8)} onMouseOver={() => onHoverOverFloor(8)} className={cls.floor8} fill="#3292ffcc" d="m 230.41517,567.20355 137.74429,-29.83858 14.60378,1.98323 430.85753,-94.29177 46.91514,18.48558 10.45392,-1.9123 82.99391,35.56882 -0.38246,-29.83191 -138.32318,-59.40885 -433.41633,103.89566 -13.25158,-2.34382 -137.96965,32.09226"></path>
            <circle className={`${cls.symbol8} ${cls.hidden}`} cx="960" cy="470" r="35" fill="#333333" />
            <text className={`${cls.symbol8} ${cls.hidden}`} x="960" y="465" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol8} ${cls.hidden}`} x="960" y="490" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">8</text>

            <path onClick={() => goToFloor(9)} onMouseOver={() => onHoverOverFloor(9)} className={cls.floor9} fill="#3292ffcc" d="m 230.23488,535.92262 139.09649,-33.62475 12.5304,2.79455 433.60602,-106.46335 46.33545,18.02936 91.76942,45.25368 0.36059,-21.27464 -13.52202,-6.85115 0.27044,-12.62055 -28.84697,-15.4151 -0.45073,-4.4172 -43.00002,-21.90566 -7.48218,1.44234 -48.76941,-22.53669 -428.91839,119.53463 -14.78407,-3.15514 -138.37531,36.4193"></path>
            <circle className={`${cls.symbol9} ${cls.hidden}`} cx="960" cy="430" r="35" fill="#333333" />
            <text className={`${cls.symbol9} ${cls.hidden}`} x="960" y="420" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol9} ${cls.hidden}`} x="960" y="450" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">9</text>

            <path onClick={() => goToFloor(10)} onMouseOver={() => onHoverOverFloor(10)} className={cls.floor10} fill="#3292ffcc" d="m 230.68562,505.18257 137.14568,-37.59285 14.27852,3.63337 429.98111,-123.82156 50.10231,25.24239 7.90418,-2.42225 48.19001,24.85993 -4.07957,3.56963 29.19447,14.53349 -0.50994,12.11125 10.70889,5.09947 -0.50995,-44.11043 L 814.76815,315.27486 381.568,445.56637 368.43686,441.10433 230.62362,483.55744"></path>
            <circle className={`${cls.symbol10} ${cls.hidden}`} cx="960" cy="390" r="35" fill="#333333" />
            <text className={`${cls.symbol10} ${cls.hidden}`} x="960" y="385" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol10} ${cls.hidden}`} x="960" y="410" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">10</text>

            <path onClick={() => goToFloor(11)} onMouseOver={() => onHoverOverFloor(11)} className={cls.floor11} fill="#3292ffcc" d="m 230.32503,477.32721 137.11325,-41.10693 14.69393,2.97484 164.15729,-47.77779 3.69602,-5.94969 264.5914,-79.43557 47.2976,24.095 8.58281,1.79338 83.47592,50.4822 -0.54088,-28.84697 -41.82811,-29.92873 -0.18029,-8.29351 -40.92664,-24.33963 -9.01468,2.70441 -46.87633,-27.58492 -265.66256,83.65621 -3.87632,7.30189 -162.80508,51.74426 -14.42349,-2.79455 -137.1115,46.9395"></path>
            <circle className={`${cls.symbol11} ${cls.hidden}`} cx="960" cy="350" r="35" fill="#333333" />
            <text className={`${cls.symbol11} ${cls.hidden}`} x="960" y="345" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol11} ${cls.hidden}`} x="960" y="370" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">11</text>

            <path onClick={() => goToFloor(12)} onMouseOver={() => onHoverOverFloor(12)} className={cls.floor12} fill="#3292ffcc" d="m 230.55988,446.7775 136.79334,-44.36541 14.9797,2.99594 162.35444,-51.50467 4.07958,-7.58546 265.70924,-86.37965 46.69717,26.87518 9.46589,-3.66524 41.06024,25.10873 0.40566,7.88784 40.92664,26.05242 -0.18029,-31.01049 -40.61968,-27.33733 -0.63743,-6.69305 -40.85952,-30.72432 -9.05157,3.18717 -47.42509,-28.17459 -266.6165,90.37315 -3.60587,7.39204 -161.90362,56.61217 -14.60378,-4.23689 -137.3837,49.49058"></path>
            <circle className={`${cls.symbol12} ${cls.hidden}`} cx="960" cy="310" r="35" fill="#333333" />
            <text className={`${cls.symbol12} ${cls.hidden}`} x="960" y="305" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol12} ${cls.hidden}`} x="960" y="330" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">12</text>

            <path onClick={() => goToFloor(13)} onMouseOver={() => onHoverOverFloor(13)} className={cls.floor13} fill="#3292ffcc" d="m 230.59547,417.10916 136.93296,-49.31029 14.78407,4.77778 163.43612,-57.24321 2.61426,-5.67924 265.84286,-94.65412 47.4172,29.11741 9.46542,-3.51573 40.83649,31.37108 0.72117,8.11321 40.02517,27.9455 0.0901,-20.73376 -12.44026,-8.65409 -1.3522,-19.4717 -26.86374,-20.19288 -1.08176,-8.92453 -42.63943,-29.38785 -6.67086,2.25367 -49.40044,-34.25578 -259.21116,98.80268 3.44214,2.03979 0.0638,8.35038 -25.49736,10.19895 -6.56557,-0.76492 -114.22818,42.26187 0.44621,4.20707 -27.34592,10.83638 -16.12708,-4.78076 -137.23955,52.20585"></path>
            <circle className={`${cls.symbol13} ${cls.hidden}`} cx="960" cy="270" r="35" fill="#333333" />
            <text className={`${cls.symbol13} ${cls.hidden}`} x="960" y="265" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol13} ${cls.hidden}`} x="960" y="290" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">13</text>

            <path onClick={() => goToFloor(14)} onMouseOver={() => onHoverOverFloor(14)} className={cls.floor14} fill="#3292ffcc" d="m 227.75517,385.99816 139.82115,-54.34124 13.83232,4.46203 25.78437,-9.15657 0.0901,-1.17191 -0.36059,-1.71279 116.74009,-44.80295 6.12998,1.44235 24.51992,-9.10483 -0.18029,-2.52411 -2.16352,-1.53249 -0.36059,-6.76101 261.15207,-103.53967 50.53043,35.65914 5.72432,-1.48742 49.84614,34.67115 0.0638,5.54568 -3.56963,0.4462 26.581,17.46569 0.25497,-32.12667 -129.3991,-99.56719 -258.86196,106.38773 -1.97604,7.39424 -168.83029,77.10921 -17.48847,-5.94969 -137.56146,59.06825"></path>
            <circle className={`${cls.symbol14} ${cls.hidden}`} cx="960" cy="230" r="35" fill="#333333" />
            <text className={`${cls.symbol14} ${cls.hidden}`} x="960" y="225" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol14} ${cls.hidden}`} x="960" y="250" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">14</text>

            <path onClick={() => goToFloor(15)} onMouseOver={() => onHoverOverFloor(15)} className={cls.floor15} fill="#3292ffcc" d="m 228.97283,357.34184 137.56399,-58.41511 16.7673,7.03145 167.13213,-75.18242 1.80294,-10.27673 L 813.66485,112.86377 940.95211,209.32083 940.77182,168.0336 814.38603,56.251592 556.38594,175.24534 l -3.06499,15.68554 -25.42139,10.81762 -6.85116,-1.62264 -109.79878,49.22014 -0.90147,4.68763 -17.84906,8.29351 -25.42139,-6.31028 -137.20341,65.80715"></path>
            <circle className={`${cls.symbol15} ${cls.hidden}`} cx="960" cy="190" r="35" fill="#333333" />
            <text className={`${cls.symbol15} ${cls.hidden}`} x="960" y="185" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol15} ${cls.hidden}`} x="960" y="210" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">15</text>
          </svg>

          <LazyLoadImage
            src="./images/blockA.png"
            alt="Structure"
            effect="blur"
          />
        </div>
      </div>
    </div>
  );
};

export default BlockA;
